import React, { useEffect, useRef, useState } from 'react'

import LoadingIcon from './LoadingIcon'

interface DropdownButtonProps {
  position: number
  icon: JSX.Element
  children?: React.ReactNode
  loading?: boolean
  showDropdown: boolean
  setShowDropdown: React.Dispatch<React.SetStateAction<boolean>>
  isLocked?: boolean
}

function DropdownButton({
  icon,
  children,
  loading,
  position,
  showDropdown,
  setShowDropdown,
  isLocked,
}: DropdownButtonProps) {
  const ref = useRef(null)

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (ref.current && !ref.current.contains(event.target)) {
        setShowDropdown(false)
      }
    }
    document.addEventListener('click', handleClickOutside, true)
    return () => {
      document.removeEventListener('click', handleClickOutside, true)
    }
  }, [])

  return (
    <div
      ref={ref}
      onClick={() => !isLocked && setShowDropdown(true)}
    >
      {loading && <LoadingIcon />}
      {!loading && (
        <div
          className={`btn btn-ghost btn-sm rounded ${showDropdown ? 'bg-gray-300' : ''} ${!isLocked && `cursor-pointer`}`}
        >
          {icon}
        </div>
      )}
      <div
        className={`${
          showDropdown && !loading ? 'visible' : 'invisible'
        } absolute shadow-lg bg-white z-50 h-55 top-12`}
        style={{ right: `${position * 25}px` }}
      >
        {children}
      </div>
    </div>
  )
}

export default DropdownButton
